import { Component, OnInit, Input } from '@angular/core';
import {ApiResource} from '../../resources/api.resource';
declare var $: any;
declare var window: any;

@Component({
  selector: 'activos-email-component',
  templateUrl: './activos-email.component.html',
  styleUrls: ['./activos-email.component.scss']
})
export class ActivosEmailComponent implements OnInit {

  @Input('configuration') configuration;
  constructor(private resource:ApiResource) { }

  ngOnInit() {
  }



  form_data = {
    nombre: null,
    telefono: null,
    email: null
  };


  rcEvent(captchaResponse: string) {
    if (captchaResponse) {
      this.enviarCorreoElectronico();
    }
  }

  enviarCorreoElectronico(){
    let data={
      form_data:this.form_data,
      to:this.configuration.general_email,
      form_name:"Davivienda Form Activos Extraordinarios"
    };

    this.resource.sendEmail(data).subscribe(resp=>{
      if(resp.response=='Success.'){
        this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('Solicitud enviada con exito.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();

      }
      else{
        this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('No se pudo procesar la solicitud.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();
      }
    },
    err=>{
      this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('No se pudo procesar la solicitud.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();
    }
    );
  }

  closeModal() {
    let $modal = $('.modal-act-wrapper');
    $modal.removeClass('active');
  }

  onlyNumbers(event) {
    let keyCode = event['keyCode'] || 0;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  sendForm(event) {
    event.preventDefault();
    grecaptcha.execute();
  }

  



}
